import styled from "styled-components";

export const Field = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const FieldLabelAndTip = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;
